<div class="transcribe-job-list-header">
  <h1
    class="availability-edit-title"
    *ngIf="!(tabs$ | async)?.length">
    {{ ("transferList" | i18n) || "Übertragungsliste" | titlecase }}
  </h1>
  <div class="tabs aligned-start condensed">
    <nav
      mat-tab-nav-bar
      class="themed-tab-nav">
      <a
        mat-tab-link
        *ngFor="let tab of tabs$ | async"
        (click)="switchTab(tab.value)"
        [active]="(activeTabId$ | async) == tab.value"
        [attr.data-cy]="
          'tab-' +
          tab.value +
          '-' +
          ((activeTabId$ | async) == tab.value ? 'active' : 'inactive')
        ">
        <mat-icon
          *ngIf="tab.svgIcon"
          [svgIcon]="tab.svgIcon"
          class="size-20"></mat-icon>
        {{ tab.label | i18n | titlecase }}
      </a>
    </nav>
  </div>
  <div class="filter-actions">
    <button
      mat-stroked-button
      class="filter-button"
      [class.collapsed]="filtersCollapsed$ | async"
      (click)="toggleFilters()"
      data-cy="transcribe-job-list-collapse-filter-button"
      type="button">
      <div class="filter-button-content">
        <mat-icon svgIcon="filter_alt_outline"></mat-icon>
        <span class="mat-fab__label">{{ ("filter" | i18n) || "Filter" }}</span>
        <span
          *ngIf="((filterCounts$ | async) || 0) > 0"
          class="badge"
          data-cy="count-badge">
          {{ filterCounts$ | async }}
        </span>
        <span
          *ngIf="(filterCounts$ | async) === 0"
          class="inverse-badge"
          data-cy="inverse-badge">
          -
        </span>
      </div>
    </button>
  </div>
</div>

<div
  class="collapse-wrapper collapse-filter"
  [class.collapsed]="filtersCollapsed$ | async"
  [class.expanded]="!(filtersCollapsed$ | async)">
  <div class="collapse-child">
    <div class="filter-bar">
      <app-date-range-select
        *ngIf="customer$ | async"
        [useQueryParam]="'range'"
        [chips]="dateRangeChips"
        [selectedRange]="(selectedRange$ | async) ?? ''"
        data-cy="date-range-select"></app-date-range-select>
      <div class="dynamic-filter-row">
        <div class="dynamic-filter-item-small">
          <app-department-select
            class="light-form-field"
            [useQueryParam]="'departmentId'"
            data-cy="department-filter">
          </app-department-select>
        </div>
        <div class="dynamic-filter-item-small">
          <app-shift-select
            [useQueryParam]="'shift'"
            [label]="'shift' | i18n"
            data-cy="shift-filter">
          </app-shift-select>
        </div>
        <div class="dynamic-filter-item-small">
          <app-certificate-select
            [lightFormField]="true"
            [withIcon]="true"
            [useQueryParam]="'certificates'"
            data-cy="certificate-filter">
          </app-certificate-select>
        </div>
        <div
          class="dynamic-filter-item-small"
          *ngIf="i18n && !(dispoCustomer$ | async)?.hiddenFields?.jobtype">
          <app-job-type-multiselect
            [useQueryParam]="'jobType'"
            [lightFormField]="true"
            data-cy="job-type-filter">
          </app-job-type-multiselect>
        </div>
      </div>
    </div>
    <div class="filter-bar">
      <div class="filter-row">
        <mat-form-field class="search-input light-form-field">
          <label>
            <input
              matInput
              type="text"
              [placeholder]="'search' | i18n | titlecase"
              [ngModel]="searchText$ | async"
              (ngModelChange)="searchText$.next($event); enableSearch()"
              data-cy="transcribe-job-list-search-input" />
          </label>
          <button
            mat-button
            matSuffix
            mat-icon-button
            aria-label="Search"
            (click)="enableSearch()">
            <mat-icon svgIcon="magnify"></mat-icon>
          </button>
        </mat-form-field>
        <mat-form-field
          class="col search-type-select light-form-field"
          data-cy="search-type-input">
          <mat-select
            [ngModel]="searchType$ | async"
            (ngModelChange)="selectSearchType($event)"
            data-cy="search-type-select">
            <mat-option
              *ngFor="let type of jobsSearchOptions$ | async"
              [value]="type">
              {{ (type.toLowerCase() | i18n) || type }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div
      class="save-filter-row"
      *ngIf="!(disableFilterSave$ | async)">
      <mat-slide-toggle
        *ngIf="(activeTabId$ | async) === 'done'"
        [checked]="showByTranscribedAtDate$ | async"
        (change)="toggleShowByTranscribedAtDate()"
        data-cy="show-by-transcribed-at-date-toggle"
        class="transcribed-date-toggle">
        {{
          ("showByTranscribedAtDate" | i18n) ||
            "Nach Übertragungsdatum anzeigen"
        }}
      </mat-slide-toggle>
      <button
        mat-button
        class="save-filter-button"
        (click)="saveTranscribeJobListFilters()"
        data-cy="save-filter-button">
        <div class="filter-actions-button-content">
          <mat-icon
            svgIcon="save"
            size></mat-icon>
          {{ "saveDefaultFilter" | i18n }}
        </div>
      </button>
    </div>
  </div>
</div>

<!-- Content area -->
<div class="transcribe-job-list-content">
  <!-- Date view (flat list by transcribedAt date) -->
  <ng-container
    *ngIf="
      (showByTranscribedAtDate$ | async) && (activeTabId$ | async) === 'done'
    ">
    <ng-container
      *ngIf="(transcribeJobs$ | async)?.loading; else dateViewContent">
      <div
        class="loading-container"
        data-cy="transcribe-job-list-loading">
        <mat-spinner diameter="48"></mat-spinner>
      </div>
    </ng-container>
    <ng-template #dateViewContent>
      <ng-container *ngIf="transcribeJobsByDate$ | async as jobsByDate">
        <ng-container *ngIf="jobsByDate.length > 0">
          <div class="transcribe-job-date-list">
            <div
              *ngFor="
                let jobItem of jobsByDate;
                trackBy: trackByTranscribeJobId
              "
              class="transcribe-job-date-item-wrapper"
              data-cy="transcribe-job-by-date-item"
              [attr.data-cy-id]="jobItem.transcribeJob.jobId">
              <div
                *ngIf="jobItem.transcribedAtInfo"
                class="transcribed-at-header">
                {{ jobItem.transcribedAtInfo }}
              </div>
              <a
                [routerLink]="['/jobs', jobItem.transcribeJob.jobId]"
                class="transcribe-job-date-item-link">
                <div
                  class="transcribe-job-date-item"
                  [attr.data-cy-job-id]="jobItem.transcribeJob.jobId"
                  [attr.data-cy-job-date]="jobItem.transcribeJob.date"
                  [attr.data-cy-status]="jobItem.transcribeJob.invitee.status"
                  [class.is-booked]="
                    jobItem.transcribeJob.invitee.status ===
                    inviteeStatusEnum.BOOKED
                  "
                  [class.is-canceled]="
                    jobItem.transcribeJob.invitee.status ===
                      inviteeStatusEnum.CANCELED ||
                    jobItem.transcribeJob.invitee.status ===
                      inviteeStatusEnum.TRANSFERRED
                  ">
                  <div class="status-bar"></div>
                  <div class="transcribe-job-date-item-content">
                    <div class="job-date-shifts-container">
                      <app-job-list-item-date-time
                        [shifts]="jobItem.transcribeJob.shifts"
                        [date]="jobItem.transcribeJob.date"
                        [withDate]="true"
                        class="transcribe-job-item-date-time"></app-job-list-item-date-time>
                    </div>
                    <app-job-list-item-organisation-heading
                      [department]="jobItem.transcribeJob.department"
                      [organisation]="jobItem.transcribeJob.organisation"
                      [departmentOnly]="false"
                      [compact]="
                        false
                      "></app-job-list-item-organisation-heading>
                    <app-transcribe-job-list-item-details-table
                      [transcribeJob]="jobItem.transcribeJob"
                      [bookedAtInfo]="jobItem.bookedAtInfo"
                      [cancelledAtInfo]="
                        jobItem.cancelledAtInfo
                      "></app-transcribe-job-list-item-details-table>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div
            *ngIf="hasMoreJobsToLoad$ | async"
            class="load-more-container">
            <button
              class="outline-pill-button"
              (click)="loadMoreJobs()"
              data-cy="load-more-jobs-button"
              type="button">
              {{ ("loadMore" | i18n) || "Mehr laden" }}
            </button>
          </div>
        </ng-container>
        <ng-container *ngIf="jobsByDate.length === 0">
          <div class="empty-state-message">
            <span>{{ "noJobsTranscribedYet" | i18n }}</span>
            <button
              *ngIf="((filterCounts$ | async) || 0) > 0"
              class="outline-pill-button"
              type="button"
              (click)="resetFilters()"
              data-cy="reset-filters-button">
              {{ ("resetFilter" | i18n) || "Filter zurücksetzen" }}
            </button>
          </div>
        </ng-container>
        <div
          *ngIf="showLimitHint$ | async"
          class="too-many-transcribe-jobs">
          <mat-icon svgIcon="information-outline"></mat-icon>
          {{ "only1kTranscribeJobsByDateShown" | i18n }}
        </div>
      </ng-container>
    </ng-template>
  </ng-container>

  <!-- Hierarchical nested view (default) -->
  <ng-container
    *ngIf="
      !(showByTranscribedAtDate$ | async) || (activeTabId$ | async) !== 'done'
    ">
    <div
      *ngIf="showLimitHint$ | async"
      class="too-many-transcribe-jobs">
      <mat-icon svgIcon="information-outline"></mat-icon>
      {{ "only1kTranscribeJobsShown" | i18n }}
    </div>
    <ng-container *ngIf="months$ | async as months">
      <ng-container *ngIf="!months.loading; else loadingSpinner">
        <ng-container *ngIf="months.months.length > 0">
          <app-accordion
            *ngFor="let monthItem of months.months; trackBy: trackByMonth"
            [collapsed]="monthItem.collapsed"
            (accordionToggled)="toggleMonthCollapsed(monthItem, $event)"
            [attr.data-cy]="'month-item-' + monthItem.month"
            class="transcribe-job-month-accordion">
            <app-accordion-header
              class="transcribe-job-month-accordion-header"
              [collapseOnHeaderClick]="true">
              {{ monthItem.month + "-01" | date: "MMMM yyyy" }}
              <div class="flex-spacer"></div>
            </app-accordion-header>
            <app-accordion-content>
              <div class="transcribe-job-month-accordion-content">
                <app-accordion
                  *ngFor="
                    let dept of monthItem.departments;
                    trackBy: trackByDepartmentId
                  "
                  [collapsed]="dept.collapsed"
                  (accordionToggled)="toggleDepartmentCollapsed(dept, $event)"
                  [attr.data-cy]="'transcribe-department-' + dept.department.id"
                  class="transcribe-job-department-accordion">
                  <app-accordion-header
                    class="transcribe-job-department-accordion-header"
                    [collapseOnHeaderClick]="true">
                    <mat-icon svgIcon="content_paste"></mat-icon>
                    <span>{{ dept.department.name }}</span>
                    <span class="organisation-label">{{
                      dept.organisation.name
                    }}</span>
                    <div class="flex-spacer"></div>
                  </app-accordion-header>
                  <app-accordion-content>
                    <div class="transcribe-job-department-accordion-content">
                      <div
                        *ngFor="let user of dept.users; trackBy: trackByUserId"
                        [attr.data-cy-user-id]="user.userId"
                        [attr.data-cy-customer-id]="user.customer.id"
                        class="transcribe-job-user-card">
                        <div class="user-header">
                          <div class="user-name">
                            {{ user.displayedName }}
                          </div>
                          <div
                            class="user-pooler-type"
                            *ngIf="user?.poolerType">
                            <div class="custom-chip small-pill poolertype-pill">
                              {{ user?.poolerType?.displayName | uppercase }}
                            </div>
                          </div>
                          <div
                            class="user-customer"
                            *ngIf="
                              (loggedInUser$ | async)?.customerId !==
                              user.customer.id
                            ">
                            via {{ user.customer.displayName }}
                          </div>
                        </div>
                        <div class="transcribe-job-list">
                          <div
                            *ngFor="let jobItem of user.jobs"
                            [attr.data-cy-job-id]="jobItem.transcribeJob.jobId"
                            [attr.data-cy-job-date]="jobItem.transcribeJob.date"
                            [attr.data-cy-status]="
                              jobItem.transcribeJob.invitee.status
                            "
                            class="transcribe-job-item"
                            [class.is-booked]="
                              jobItem.transcribeJob.invitee.status ===
                              inviteeStatusEnum.BOOKED
                            "
                            [class.is-canceled]="
                              jobItem.transcribeJob.invitee.status ===
                                inviteeStatusEnum.CANCELED ||
                              jobItem.transcribeJob.invitee.status ===
                                inviteeStatusEnum.TRANSFERRED
                            ">
                            <div
                              class="status-bar"
                              [matTooltip]="
                                jobItem.bookedAtInfo ||
                                jobItem.cancelledAtInfo ||
                                ''
                              "
                              matTooltipPosition="above"
                              [matTooltipShowDelay]="100"></div>
                            <div class="transcribe-job-item-content">
                              <div class="job-date-type-container">
                                <app-job-list-item-date-time
                                  [shifts]="jobItem.transcribeJob.shifts"
                                  [date]="jobItem.transcribeJob.date"
                                  [withDate]="true"
                                  class="transcribe-job-item-date-time"></app-job-list-item-date-time>
                                <div
                                  *ngIf="jobItem.transcribeJob.jobType"
                                  class="job-type text-grey text-m"
                                  [matTooltip]="'jobType' | i18n">
                                  {{
                                    "jobTypeEnum." +
                                      jobItem.transcribeJob.jobType | i18n
                                  }}
                                </div>
                              </div>
                              <ng-container
                                *ngIf="
                                  !jobItem.transcribeJob.transcribedAt &&
                                  (canUpdateTranscribeJobList$ | async)
                                ">
                                <button
                                  class="outline-pill-button text-secondary transcribe-job-button"
                                  type="button"
                                  [disabled]="
                                    transcribingJobIds.has(
                                      jobItem.transcribeJob._id
                                    )
                                  "
                                  (click)="
                                    transcribeJob(jobItem.transcribeJob._id)
                                  "
                                  data-cy="transcribe-job-button">
                                  <mat-icon
                                    svgIcon="check-circle-outline"></mat-icon>
                                  {{ "toComplete" | i18n | titlecase }}
                                </button>
                              </ng-container>
                              <span
                                *ngIf="
                                  jobItem.transcribeJob.transcribedAt &&
                                  jobItem.transcribeJob.invitee.status ===
                                    inviteeStatusEnum.BOOKED
                                "
                                class="text-s transcribe-job-hint"
                                [title]="jobItem.bookedAtInfo">
                                {{ jobItem.bookedAtInfo }}
                              </span>
                              <span
                                *ngIf="
                                  jobItem.transcribeJob.transcribedAt &&
                                  jobItem.transcribeJob.invitee.status ===
                                    inviteeStatusEnum.CANCELED
                                "
                                class="text-s transcribe-job-hint"
                                [title]="jobItem.cancelledAtInfo">
                                {{ jobItem.cancelledAtInfo }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </app-accordion-content>
                </app-accordion>
              </div>
            </app-accordion-content>
          </app-accordion>
        </ng-container>
        <ng-container *ngIf="months.months.length === 0">
          <div class="empty-state-message">
            <ng-container [ngSwitch]="(months$ | async)?.activeTabId">
              <span *ngSwitchCase="'open'">
                {{ "noJobsToTranscribe" | i18n }}
              </span>
              <span *ngSwitchDefault>
                {{ "noJobsTranscribedYet" | i18n }}
              </span>
            </ng-container>
            <button
              *ngIf="((filterCounts$ | async) || 0) > 0"
              class="outline-pill-button"
              type="button"
              (click)="resetFilters()"
              data-cy="reset-filters-button">
              {{ ("resetFilter" | i18n) || "Filter zurücksetzen" }}
            </button>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</div>

<ng-template #loadingSpinner>
  <div
    class="loading-container"
    data-cy="transcribe-job-list-loading">
    <mat-spinner diameter="48"></mat-spinner>
  </div>
</ng-template>
